import React, { useState, useEffect } from "react";
import './App.css';
import './Global.css';
import Navibar from './Navbar';
import Footer from "./footer";
import About from './about';
import Home from "./Home";
import Venue from "./Venue";
import Accommodation from "./Accommodation";
import Registry from "./Registry";
import OOTD from "./OOTD";
import FAQ from "./FAQ";
import RSVP from "./RSVP";
import Timeline from "./Timeline";
import './Fonts.css';
import {  BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './Login';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authStatus = sessionStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    sessionStorage.setItem('isAuthenticated', 'true');
  };

  return (
    <Router>
      <div className="App">
      {isAuthenticated ? (
        <>
          <Navibar />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/venue" element={<Venue />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/ootd" element={<OOTD />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/rsvp" element={<RSVP/>} />
            <Route path="/timeline" element={<Timeline />} />
          </Routes>
          <Footer />
        </>
        ) : (
          <Login onLogin={handleLogin} />
        )}
      </div>
     </Router>
  );
}

export default App;

